export default __webpack_public_path__ + "static/poster_sessions-842662ec703784f61cd9aa7537abf230.png";